class ParseUtils {
  parseNumber(value) {
    if (typeof value === "string") {
      const cleanValue = value.replace(/ /g, "").replace(",", ".");
      if (!cleanValue) return;
      return parseFloat(cleanValue);
    }
    return value;
  }
}

export default new ParseUtils();
